export default __webpack_public_path__ + "static/urbra_logo_small-ceb2c2813d155db9f2614d3de7252385.jpg";